import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const colors = [
    "rgba(255, 99, 132, 0.6)",
    "rgba(54, 162, 235, 0.6)",
    "rgba(255, 206, 86, 0.6)",
    "rgba(75, 192, 192, 0.6)",
    "rgba(153, 102, 255, 0.6)",
    "rgba(255, 159, 64, 0.6)"
];
const BarChart = ({ barChartData }) => {
    // 1️⃣ All event names (x-axis)
    const events = Object.keys(barChartData);
    const feeTypes = [
        ...new Set(Object.values(barChartData).flatMap(fees => Object.keys(fees)))
    ];

    // 3️⃣ Build datasets per fee type (each color = one bar group)
    const datasets = feeTypes.map((fee, i) => ({
        label: fee,
        data: events.map(event => {
            // Sum up the fee data for that event (e.g. [2, 1] → 3)
            const values = barChartData[event]?.[fee];
            return values ? values.reduce((a, b) => a + b, 0) : 0;
        }),
        backgroundColor: colors[i % colors.length],
    }));

    // 4️⃣ Final data object
    const data = {
        labels: events, // x-axis = events
        datasets: datasets,
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "top" },
            title: { display: true, text: "Monthly Sales Overview" },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { stepSize: 500 },
            },
        },
    };

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <Bar data={data} options={options} style={{ height: '100%' }} />
        </div>
    );
};

export default BarChart;
